import { ReactNode, forwardRef } from 'react';

type RelativeProps = {
    children: ReactNode;
    className?: string;
    zIndex?: number;
    left?: number;
    top?: number;
};

const Relative = forwardRef<HTMLDivElement, RelativeProps>(
    ({ children, className, zIndex, left, top }, ref) => {
        return (
            <div
                className={className}
                style={{
                    position: 'relative',
                    zIndex: zIndex,
                    left: left,
                    top: top,
                }}
                ref={ref}
            >
                {children}
            </div>
        );
    }
);

export default Relative;
